import * as React from 'react'

import { StackChildren } from '@doordash/design-language'

import JobCard from '../../atoms/driving-opportunities-job-card'

import * as GLOBAL_CONSTANT from '../../../constants'
import * as CONSTANT from './constants'

type Props = {
  slug: string
  cityState: string
}

const BASE_URL = GLOBAL_CONSTANT.BASE_PATH

const Home = () => (
  <React.Fragment>
    <JobCard
      cityOverride={`${CONSTANT.HOME_CITY_1}`}
      buttonHref={`${BASE_URL}/${CONSTANT.HOME_CITY_SLUG_1}/${
        GLOBAL_CONSTANT.JOB_TYPE_1
      }/`}
      title={`${GLOBAL_CONSTANT.JOB_1} ${GLOBAL_CONSTANT.JOB_SUFFIX}`}
      description={`${CONSTANT.HOME_DESCRIPTION_1}`}
      buttonName={`${CONSTANT.BUTTON_NAME_1}`}
      imageUrl={`${CONSTANT.IMG_URL_DESKTOP_1}`}
    />
    <JobCard
      cityOverride={`${CONSTANT.HOME_CITY_2}`}
      buttonHref={`${BASE_URL}/${CONSTANT.HOME_CITY_SLUG_2}/${
        GLOBAL_CONSTANT.JOB_TYPE_2
      }/`}
      title={`${GLOBAL_CONSTANT.JOB_2} ${GLOBAL_CONSTANT.JOB_SUFFIX}`}
      description={`${CONSTANT.HOME_DESCRIPTION_2}`}
      buttonName={`${CONSTANT.BUTTON_NAME_2}`}
      imageUrl={`${CONSTANT.IMG_URL_DESKTOP_2}`}
      flipImage={true}
    />
  </React.Fragment>
)

const City = ({ cityState, slug }) => (
  <React.Fragment>
    <JobCard
      slug={slug}
      cityState={cityState}
      buttonHref={`${BASE_URL}/${slug}/${GLOBAL_CONSTANT.JOB_TYPE_1}/`}
      title={`${GLOBAL_CONSTANT.JOB_1} ${GLOBAL_CONSTANT.JOB_SUFFIX}`}
      description={`${CONSTANT.JOB_DESCRIPTION_1}`}
      buttonName={`${CONSTANT.BUTTON_NAME_1}`}
      imageUrl={`${CONSTANT.IMG_URL_1}`}
    />
    <JobCard
      slug={slug}
      cityState={cityState}
      buttonHref={`${BASE_URL}/${slug}/${GLOBAL_CONSTANT.JOB_TYPE_2}/`}
      title={`${GLOBAL_CONSTANT.JOB_2} ${GLOBAL_CONSTANT.JOB_SUFFIX}`}
      description={`${CONSTANT.JOB_DESCRIPTION_2}`}
      buttonName={`${CONSTANT.BUTTON_NAME_2}`}
      imageUrl={`${CONSTANT.IMG_URL_2}`}
    />
    <JobCard
      slug={slug}
      cityState={cityState}
      buttonHref={`${BASE_URL}/${slug}/${GLOBAL_CONSTANT.JOB_TYPE_3}/`}
      title={`${GLOBAL_CONSTANT.JOB_3} ${GLOBAL_CONSTANT.JOB_SUFFIX}`}
      description={`${CONSTANT.JOB_DESCRIPTION_3}`}
      buttonName={`${CONSTANT.BUTTON_NAME_3}`}
      imageUrl={`${CONSTANT.IMG_URL_3}`}
    />
    <JobCard
      slug={slug}
      cityState={cityState}
      buttonHref={`${BASE_URL}/${slug}/${GLOBAL_CONSTANT.JOB_TYPE_4}/`}
      title={`${GLOBAL_CONSTANT.JOB_4} ${GLOBAL_CONSTANT.JOB_SUFFIX}`}
      description={`${CONSTANT.JOB_DESCRIPTION_4}`}
      buttonName={`${CONSTANT.BUTTON_NAME_4}`}
      imageUrl={`${CONSTANT.IMG_URL_4}`}
    />
  </React.Fragment>
)
const DrivingOpportunitiesJobSection: React.SFC<Props> = ({
  cityState,
  slug,
}) => (
  <StackChildren size={StackChildren.Sizes.XLarge}>
    {slug && <City cityState={cityState} slug={slug} />}
    {!slug && <Home />}
  </StackChildren>
)

export default DrivingOpportunitiesJobSection
